// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2W0im","alertIcon":"ConfirmModal_alertIcon__29-22"};